module.exports = __webpack_public_path__ + "img/wlw-bg.f6eb81a9.png";